export const stockData = [
    {
      "id": 5,
      "name": "Admiral",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Bird",
      "birthday": "  January 27",
      "catchphrase": "  aye aye",
      "hobby": "  Nature"
    },
    {
      "id": 6,
      "name": "Agent S",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Squirrel",
      "birthday": "  July 2",
      "catchphrase": "  sidekick",
      "hobby": "  Fitness"
    },
    {
      "id": 7,
      "name": "Agnes",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Pig",
      "birthday": "  April 21",
      "catchphrase": "  snuffle",
      "hobby": "  Play"
    },
    {
      "id": 8,
      "name": "Al",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Gorilla",
      "birthday": "  October 18",
      "catchphrase": "  ayyeeee",
      "hobby": "  Fitness"
    },
    {
      "id": 9,
      "name": "Alfonso",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Alligator",
      "birthday": "  June 9",
      "catchphrase": "  it'sa me",
      "hobby": "  Play"
    },
    {
      "id": 10,
      "name": "Alice",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Koala",
      "birthday": "  August 19",
      "catchphrase": "  guvnor",
      "hobby": "  Education"
    },
    {
      "id": 11,
      "name": "Alli",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Alligator",
      "birthday": "  November 8",
      "catchphrase": "  graaagh",
      "hobby": "  Fashion"
    },
    {
      "id": 12,
      "name": "Amelia",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Eagle",
      "birthday": "  November 19",
      "catchphrase": "  cuz",
      "hobby": "  Music"
    },
    {
      "id": 13,
      "name": "Anabelle",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Anteater",
      "birthday": "  February 16",
      "catchphrase": "  snorty",
      "hobby": "  Fashion"
    },
    {
      "id": 14,
      "name": "Anchovy",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Bird",
      "birthday": "  March 4",
      "catchphrase": "  chuurp",
      "hobby": "  Play"
    },
    {
      "id": 15,
      "name": "Angus",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Bull",
      "birthday": "  April 30",
      "catchphrase": "  macmoo",
      "hobby": "  Fitness"
    },
    {
      "id": 16,
      "name": "Anicotti",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Mouse",
      "birthday": "  February 24",
      "catchphrase": "   cannoli ",
      "hobby": "  Fashion"
    },
    {
      "id": 17,
      "name": "Ankha",
      "gender": "Female",
      "personality": "Snooty",
      "species": " Cat",
      "birthday": "  September 22",
      "catchphrase": "  me meow",
      "hobby": "  Nature"
    },
    {
      "id": 18,
      "name": "Annalisa",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Anteater",
      "birthday": "  February 6",
      "catchphrase": "  gumdrop",
      "hobby": "  Nature"
    },
    {
      "id": 19,
      "name": "Annalise",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Horse",
      "birthday": "  December 2",
      "catchphrase": "  nipper",
      "hobby": "  Fashion"
    },
    {
      "id": 20,
      "name": "Antonio",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Anteater",
      "birthday": "  October 20",
      "catchphrase": "  honk",
      "hobby": "  Fitness"
    },
    {
      "id": 21,
      "name": "Apollo",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Eagle",
      "birthday": "  July 4",
      "catchphrase": "  pah",
      "hobby": "  Music"
    },
    {
      "id": 22,
      "name": "Apple",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Hamster",
      "birthday": "  September 24",
      "catchphrase": "  cheekers",
      "hobby": "  Play"
    },
    {
      "id": 23,
      "name": "Astrid",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Kangaroo",
      "birthday": "  September 8",
      "catchphrase": "  my pet",
      "hobby": "  Music"
    },
    {
      "id": 24,
      "name": "Audie",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Wolf",
      "birthday": "  August 31",
      "catchphrase": "  foxtrot",
      "hobby": "  Fitness"
    },
    {
      "id": 25,
      "name": "Aurora",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Penguin",
      "birthday": "  January 27",
      "catchphrase": "  b-b-baby",
      "hobby": "  Education"
    },
    {
      "id": 26,
      "name": "Ava",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Chicken",
      "birthday": "  April 28",
      "catchphrase": "  beaker",
      "hobby": "  Music"
    },
    {
      "id": 27,
      "name": "Avery",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Eagle",
      "birthday": "  February 22",
      "catchphrase": "  skree-haw",
      "hobby": "  Music"
    },
    {
      "id": 28,
      "name": "Axel",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Elephant",
      "birthday": "  March 23r",
      "catchphrase": "  WHONK",
      "hobby": "  Fitness"
    },
    {
      "id": 29,
      "name": "Baabara",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Sheep",
      "birthday": "  March 28",
      "catchphrase": "  daahling",
      "hobby": "  Fashion"
    },
    {
      "id": 30,
      "name": "Bam",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Deer",
      "birthday": "  November 7",
      "catchphrase": "  kablang",
      "hobby": "  Play"
    },
    {
      "id": 31,
      "name": "Bangle",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Tiger",
      "birthday": "  August 27",
      "catchphrase": "  growf",
      "hobby": "  Fashion"
    },
    {
      "id": 32,
      "name": "Barold",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Cub",
      "birthday": "  March 2",
      "catchphrase": "  cubby",
      "hobby": "  Play"
    },
    {
      "id": 33,
      "name": "Bea",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Dog",
      "birthday": "  October 15",
      "catchphrase": "  bingo",
      "hobby": "  Nature"
    },
    {
      "id": 34,
      "name": "Beardo",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Bear",
      "birthday": "  September 27",
      "catchphrase": "  whiskers",
      "hobby": "  Education"
    },
    {
      "id": 35,
      "name": "Beau",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Deer",
      "birthday": "  April 5",
      "catchphrase": "  saltlick",
      "hobby": "  Nature"
    },
    {
      "id": 36,
      "name": "Becky",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Chicken",
      "birthday": "  December 9",
      "catchphrase": "  chicklet",
      "hobby": "  Music"
    },
    {
      "id": 37,
      "name": "Bella",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Mouse",
      "birthday": "  December 28",
      "catchphrase": "  eeks",
      "hobby": "  Music"
    },
    {
      "id": 38,
      "name": "Benedict",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Chicken",
      "birthday": "  October 10",
      "catchphrase": "  uh-hoo",
      "hobby": "  Play"
    },
    {
      "id": 39,
      "name": "Benjamin",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Dog",
      "birthday": "  August 3r",
      "catchphrase": "  alrighty",
      "hobby": "  Nature"
    },
    {
      "id": 40,
      "name": "Bertha",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Hippo",
      "birthday": "  April 25",
      "catchphrase": "  bloop",
      "hobby": "  Education"
    },
    {
      "id": 41,
      "name": "Bettina",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Mouse",
      "birthday": "  June 12",
      "catchphrase": "  eekers",
      "hobby": "  Education"
    },
    {
      "id": 42,
      "name": "Bianca",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Tiger",
      "birthday": "  December 13",
      "catchphrase": "  glimmer",
      "hobby": "  Play"
    },
    {
      "id": 43,
      "name": "Biff",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Hippo",
      "birthday": "  March 29",
      "catchphrase": "  squirt",
      "hobby": "  Fitness"
    },
    {
      "id": 44,
      "name": "Big Top",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Elephant",
      "birthday": "  October 3r",
      "catchphrase": "  villain",
      "hobby": "  Play"
    },
    {
      "id": 45,
      "name": "Bill",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Duck",
      "birthday": "  February 1",
      "catchphrase": "  quacko",
      "hobby": "  Play"
    },
    {
      "id": 46,
      "name": "Billy",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Goat",
      "birthday": "  March 25",
      "catchphrase": "  dagnaabit",
      "hobby": "  Play"
    },
    {
      "id": 47,
      "name": "Biskit",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Dog",
      "birthday": "  May 13",
      "catchphrase": "  dawg",
      "hobby": "  Play"
    },
    {
      "id": 48,
      "name": "Bitty",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Hippo",
      "birthday": "  October 6",
      "catchphrase": "  my dear",
      "hobby": "  Education"
    },
    {
      "id": 49,
      "name": "Blaire",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Squirrel",
      "birthday": "  July 3r",
      "catchphrase": "  nutlet",
      "hobby": "  Fashion"
    },
    {
      "id": 50,
      "name": "Blanche",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Ostrich",
      "birthday": "  December 21",
      "catchphrase": "  quite so",
      "hobby": "  Nature"
    },
    {
      "id": 51,
      "name": "Bluebear",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Cub",
      "birthday": "  June 24",
      "catchphrase": "  peach",
      "hobby": "  Fashion"
    },
    {
      "id": 52,
      "name": "Bob",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Cat",
      "birthday": "  January 1",
      "catchphrase": "  pthhpth",
      "hobby": "  Play"
    },
    {
      "id": 53,
      "name": "Bonbon",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Rabbit",
      "birthday": "  March 3r",
      "catchphrase": "  deelish",
      "hobby": "  Play"
    },
    {
      "id": 54,
      "name": "Bones",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Dog",
      "birthday": "  August 4",
      "catchphrase": "  yip yip",
      "hobby": "  Play"
    },
    {
      "id": 55,
      "name": "Boomer",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Penguin",
      "birthday": "  February 7",
      "catchphrase": "  human",
      "hobby": " Fitness"
    },
    {
      "id": 56,
      "name": "Boone",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Gorilla",
      "birthday": "  September 12",
      "catchphrase": "  baboom",
      "hobby": "  Fitness"
    },
    {
      "id": 57,
      "name": "Boots",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Alligator",
      "birthday": "  August 7",
      "catchphrase": "  munchie",
      "hobby": "  Play"
    },
    {
      "id": 58,
      "name": "Boris",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Pig",
      "birthday": "  November 6",
      "catchphrase": "  schnort",
      "hobby": "  Nature"
    },
    {
      "id": 59,
      "name": "Boyd",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Gorilla",
      "birthday": "  October 1",
      "catchphrase": "  uh-oh",
      "hobby": "  Fitness"
    },
    {
      "id": 60,
      "name": "Bree",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Mouse",
      "birthday": "  July 7",
      "catchphrase": "  cheeseball",
      "hobby": "  Fashion"
    },
    {
      "id": 61,
      "name": "Broccolo",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Mouse",
      "birthday": "  June 30",
      "catchphrase": "  eat it",
      "hobby": "  Play"
    },
    {
      "id": 62,
      "name": "Broffina",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Chicken",
      "birthday": "  October 24",
      "catchphrase": "  cluckadoo",
      "hobby": "  Music"
    },
    {
      "id": 63,
      "name": "Bruce",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Deer",
      "birthday": "  May 26",
      "catchphrase": "  gruff",
      "hobby": "  Nature"
    },
    {
      "id": 64,
      "name": "Bubbles",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Hippo",
      "birthday": "  September 18",
      "catchphrase": "  hipster",
      "hobby": "  Fashion"
    },
    {
      "id": 65,
      "name": "Buck",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Horse",
      "birthday": "  April 4",
      "catchphrase": "  pardner",
      "hobby": "  Fitness"
    },
    {
      "id": 66,
      "name": "Bud",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Lion",
      "birthday": "  August 8",
      "catchphrase": "  shredded",
      "hobby": "  Fitness"
    },
    {
      "id": 67,
      "name": "Bunnie",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Rabbit",
      "birthday": "  May 9",
      "catchphrase": "  tee-hee",
      "hobby": "  Fashion"
    },
    {
      "id": 68,
      "name": "Butch",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Dog",
      "birthday": "  November 1",
      "catchphrase": "  ROOOOOWF",
      "hobby": "  Music"
    },
    {
      "id": 69,
      "name": "Buzz",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Eagle",
      "birthday": "  December 7",
      "catchphrase": "  captain",
      "hobby": "  Nature"
    },
    {
      "id": 70,
      "name": "Cally",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Squirrel",
      "birthday": "  September 4",
      "catchphrase": "  WHEE",
      "hobby": "  Nature"
    },
    {
      "id": 71,
      "name": "Camofrog",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Frog",
      "birthday": "  June 5",
      "catchphrase": "  ten-hut",
      "hobby": "  Music"
    },
    {
      "id": 72,
      "name": "Canberra",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Koala",
      "birthday": "  May 14",
      "catchphrase": "  nuh uh",
      "hobby": "  Play"
    },
    {
      "id": 73,
      "name": "Candi",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Mouse",
      "birthday": "  April 13",
      "catchphrase": "  sweetie",
      "hobby": "  Play"
    },
    {
      "id": 74,
      "name": "Carmen",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Rabbit",
      "birthday": "  January 6",
      "catchphrase": "  nougat",
      "hobby": "  Fashion"
    },
    {
      "id": 75,
      "name": "Caroline",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Squirrel",
      "birthday": "  July 15",
      "catchphrase": "  hulaaaa",
      "hobby": "  Music"
    },
    {
      "id": 76,
      "name": "Carrie",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Kangaroo",
      "birthday": "  December 5",
      "catchphrase": "  little one",
      "hobby": "  Nature"
    },
    {
      "id": 77,
      "name": "Cashmere",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Sheep",
      "birthday": "  April 2",
      "catchphrase": "  baaaby",
      "hobby": "  Fashion"
    },
    {
      "id": 78,
      "name": "Celia",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Eagle",
      "birthday": "  March 25",
      "catchphrase": "  feathers",
      "hobby": "  Nature"
    },
    {
      "id": 79,
      "name": "Cesar",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Gorilla",
      "birthday": "  September 6",
      "catchphrase": "  highness",
      "hobby": "  Fitness"
    },
    {
      "id": 80,
      "name": "Chadder",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Mouse",
      "birthday": "  December 15",
      "catchphrase": "  fromage",
      "hobby": "  Fitness"
    },
    {
      "id": 81,
      "name": "Charlise",
      "gender": "Female",
      "personality": "Sisterly",
      "species": " Bear",
      "birthday": "  April 17",
      "catchphrase": "  urgh",
      "hobby": "  Fitness"
    },
    {
      "id": 82,
      "name": "Cheri",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Cub",
      "birthday": "  March 17",
      "catchphrase": "  tralala",
      "hobby": "  Fashion"
    },
    {
      "id": 83,
      "name": "Cherry",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Dog",
      "birthday": "  May 11",
      "catchphrase": "  what what",
      "hobby": "   Music"
    },
    {
      "id": 84,
      "name": "Chester",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Cub",
      "birthday": "  August 6",
      "catchphrase": "  rookie",
      "hobby": "  Play"
    },
    {
      "id": 85,
      "name": "Chevre",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Goat",
      "birthday": "  March 6",
      "catchphrase": "  la baa",
      "hobby": " Education"
    },
    {
      "id": 86,
      "name": "Chief",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Wolf",
      "birthday": "  December 19",
      "catchphrase": "  harrumph",
      "hobby": "  Music"
    },
    {
      "id": 87,
      "name": "Chops",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Pig",
      "birthday": "  October 13",
      "catchphrase": "  zoink",
      "hobby": "  Education"
    },
    {
      "id": 88,
      "name": "Chow",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Bear",
      "birthday": "  July 22",
      "catchphrase": "  aiya",
      "hobby": "  Fitness"
    },
    {
      "id": 89,
      "name": "Chrissy",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Rabbit",
      "birthday": "  August 28",
      "catchphrase": "  sparkles",
      "hobby": "  Fashion"
    },
    {
      "id": 90,
      "name": "Claude",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Rabbit",
      "birthday": "  December 3r",
      "catchphrase": "  hopalong",
      "hobby": "  Nature"
    },
    {
      "id": 91,
      "name": "Claudia",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Tiger",
      "birthday": "  November 22",
      "catchphrase": "  ooh la la",
      "hobby": "  Music"
    },
    {
      "id": 92,
      "name": "Clay",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Hamster",
      "birthday": "  October 19",
      "catchphrase": "  thump",
      "hobby": "  Nature"
    },
    {
      "id": 93,
      "name": "Cleo",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Horse",
      "birthday": "  February 9",
      "catchphrase": "  sugar",
      "hobby": "  Education"
    },
    {
      "id": 94,
      "name": "Clyde",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Horse",
      "birthday": "  May 1",
      "catchphrase": "  clip clawp",
      "hobby": "  Play"
    },
    {
      "id": 95,
      "name": "Coach",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Bull",
      "birthday": "  April 29",
      "catchphrase": "  stubble",
      "hobby": "  Fitness"
    },
    {
      "id": 96,
      "name": "Cobb",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Pig",
      "birthday": "  October 7",
      "catchphrase": "  hot dog",
      "hobby": "  Education"
    },
    {
      "id": 97,
      "name": "Coco",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Rabbit",
      "birthday": "  March 1",
      "catchphrase": "  doyoing",
      "hobby": "  Education"
    },
    {
      "id": 98,
      "name": "Cole",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Rabbit",
      "birthday": "  August 10",
      "catchphrase": "  coooooool",
      "hobby": "  Nature"
    },
    {
      "id": 99,
      "name": "Colton",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Horse",
      "birthday": "  May 22",
      "catchphrase": "  check it",
      "hobby": "  Nature"
    },
    {
      "id": 100,
      "name": "Cookie",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Dog",
      "birthday": "  June 18",
      "catchphrase": "  arfer",
      "hobby": "  Fashion"
    },
    {
      "id": 101,
      "name": "Cousteau",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Frog",
      "birthday": "  December 17",
      "catchphrase": "  oui oui",
      "hobby": "  Fitness"
    },
    {
      "id": 102,
      "name": "Cranston",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Ostrich",
      "birthday": "  September 23r",
      "catchphrase": "  sweatband",
      "hobby": "  Nature"
    },
    {
      "id": 103,
      "name": "Croque",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Frog",
      "birthday": "  July 18",
      "catchphrase": "  as if",
      "hobby": "  Nature"
    },
    {
      "id": 104,
      "name": "Cube",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Penguin",
      "birthday": "  January 29",
      "catchphrase": "  brainfreeze",
      "hobby": "  Play"
    },
    {
      "id": 105,
      "name": "Curlos",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Sheep",
      "birthday": "  May 8",
      "catchphrase": "  shearly",
      "hobby": "  Nature"
    },
    {
      "id": 106,
      "name": "Curly",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Pig",
      "birthday": "  July 26",
      "catchphrase": "  nyoink",
      "hobby": "  Fitness"
    },
    {
      "id": 107,
      "name": "Curt",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Bear",
      "birthday": "  July 1",
      "catchphrase": "  fuzzball",
      "hobby": "  Nature"
    },
    {
      "id": 108,
      "name": "Cyd",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Elephant",
      "birthday": "  June 9",
      "catchphrase": "  rockin'",
      "hobby": "  Music"
    },
    {
      "id": 109,
      "name": "Cyrano",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Anteater",
      "birthday": "  March 9",
      "catchphrase": "  ah-CHOO",
      "hobby": "  Education"
    },
    {
      "id": 110,
      "name": "Daisy",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Dog",
      "birthday": "  November 16",
      "catchphrase": "  bow-WOW",
      "hobby": "  Education"
    },
    {
      "id": 111,
      "name": "Deena",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Duck",
      "birthday": "  June 27",
      "catchphrase": "  woowoo",
      "hobby": "  Education"
    },
    {
      "id": 112,
      "name": "Deirdre",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Deer",
      "birthday": "  May 4",
      "catchphrase": "  whatevs",
      "hobby": "  Play"
    },
    {
      "id": 113,
      "name": "Del",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Alligator",
      "birthday": "  May 27",
      "catchphrase": "  gronk",
      "hobby": "  Fitness"
    },
    {
      "id": 114,
      "name": "Deli",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Monkey",
      "birthday": "  May 24",
      "catchphrase": "  monch",
      "hobby": "  Nature"
    },
    {
      "id": 115,
      "name": "Derwin",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Duck",
      "birthday": "  May 25",
      "catchphrase": "  derrrrr",
      "hobby": "  Play"
    },
    {
      "id": 116,
      "name": "Diana",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Deer",
      "birthday": "  January 4",
      "catchphrase": "  no doy",
      "hobby": "  Education"
    },
    {
      "id": 117,
      "name": "Diva",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Frog",
      "birthday": "  October 2",
      "catchphrase": "  ya know",
      "hobby": "  Fitness"
    },
    {
      "id": 118,
      "name": "Dizzy",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Elephant",
      "birthday": "  July 14",
      "catchphrase": "  woo-oo",
      "hobby": "  Play"
    },
    {
      "id": 119,
      "name": "Dobie",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Wolf",
      "birthday": "  February 17",
      "catchphrase": "  ohmmm",
      "hobby": "  Nature"
    },
    {
      "id": 120,
      "name": "Doc",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Rabbit",
      "birthday": "  March 16",
      "catchphrase": "  old bunny",
      "hobby": "  Education"
    },
    {
      "id": 121,
      "name": "Dom",
      "gender": "Male",
      "personality": "Jock",
      "species": " Sheep",
      "birthday": "  March 18",
      "catchphrase": "  indeedaroo",
      "hobby": "  Play"
    },
    {
      "id": 122,
      "name": "Dora",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Mouse",
      "birthday": "  February 18",
      "catchphrase": "  squeaky",
      "hobby": "  Education"
    },
    {
      "id": 123,
      "name": "Dotty",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Rabbit",
      "birthday": "  March 14",
      "catchphrase": "  wee one",
      "hobby": "  Fashion"
    },
    {
      "id": 124,
      "name": "Drago",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Alligator",
      "birthday": "  February 12",
      "catchphrase": "  burrrn",
      "hobby": "  Nature"
    },
    {
      "id": 125,
      "name": "Drake",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Duck",
      "birthday": "  June 25",
      "catchphrase": "  quacko",
      "hobby": "  Play"
    },
    {
      "id": 126,
      "name": "Drift",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Frog",
      "birthday": "  October 9",
      "catchphrase": "  dribbit",
      "hobby": "  Fitness"
    },
    {
      "id": 127,
      "name": "Ed",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Horse",
      "birthday": "  September 16",
      "catchphrase": "  greenhorn",
      "hobby": "  Nature"
    },
    {
      "id": 128,
      "name": "Egbert",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Chicken",
      "birthday": "  October 14",
      "catchphrase": "  doodle-duh",
      "hobby": "  Play"
    },
    {
      "id": 129,
      "name": "Elise",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Monkey",
      "birthday": "  March 21",
      "catchphrase": "  puh-lease",
      "hobby": "  Fashion"
    },
    {
      "id": 130,
      "name": "Ellie",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Elephant",
      "birthday": "  May 12",
      "catchphrase": "  li'l one",
      "hobby": "  Nature"
    },
    {
      "id": 131,
      "name": "Elmer",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Horse",
      "birthday": "  October 5",
      "catchphrase": "  tenderfoot",
      "hobby": "  Play"
    },
    {
      "id": 132,
      "name": "Eloise",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Elephant",
      "birthday": "  December 8",
      "catchphrase": "  tooooot",
      "hobby": "  Fashion"
    },
    {
      "id": 133,
      "name": "Elvis",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Lion",
      "birthday": "  July 23r",
      "catchphrase": "  unh-hunh",
      "hobby": "  Education"
    },
    {
      "id": 134,
      "name": "Erik",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Deer",
      "birthday": "  July 27",
      "catchphrase": "  chow down",
      "hobby": "  Nature"
    },
    {
      "id": 135,
      "name": "Eugene",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Koala",
      "birthday": "  October 26",
      "catchphrase": "  yeah buddy",
      "hobby": "  Music"
    },
    {
      "id": 136,
      "name": "Eunice",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Sheep",
      "birthday": "  April 3r",
      "catchphrase": "  lambchop",
      "hobby": "  Fashion"
    },
    {
      "id": 137,
      "name": "Fang",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Wolf",
      "birthday": "  December 18",
      "catchphrase": "  cha-chomp",
      "hobby": "  Education"
    },
    {
      "id": 138,
      "name": "Fauna",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Deer",
      "birthday": "  March 26",
      "catchphrase": "  dearie",
      "hobby": "  Nature"
    },
    {
      "id": 139,
      "name": "Felicity",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Cat",
      "birthday": "  March 30",
      "catchphrase": "  mimimi",
      "hobby": "  Fashion"
    },
    {
      "id": 140,
      "name": "Filbert",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Squirrel",
      "birthday": "  June 3r",
      "catchphrase": "  bucko",
      "hobby": "  Nature"
    },
    {
      "id": 141,
      "name": "Flip",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Monkey",
      "birthday": "  November 21",
      "catchphrase": "  rerack",
      "hobby": "  Music"
    },
    {
      "id": 142,
      "name": "Flo",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Penguin",
      "birthday": "  September 2",
      "catchphrase": "  cha",
      "hobby": "  Music"
    },
    {
      "id": 143,
      "name": "Flora",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Ostrich",
      "birthday": "  February 9",
      "catchphrase": "  pinky",
      "hobby": "  Play"
    },
    {
      "id": 144,
      "name": "Flurry",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Hamster",
      "birthday": "  January 30",
      "catchphrase": "  powderpuff",
      "hobby": "  Nature"
    },
    {
      "id": 145,
      "name": "Francine",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Rabbit",
      "birthday": "  January 22",
      "catchphrase": "  karat",
      "hobby": "  Fashion"
    },
    {
      "id": 146,
      "name": "Frank",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Eagle",
      "birthday": "  July 30",
      "catchphrase": "  crushy",
      "hobby": "  Education"
    },
    {
      "id": 147,
      "name": "Freckles",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Duck",
      "birthday": "  February 19",
      "catchphrase": "  ducky",
      "hobby": "  Fashion"
    },
    {
      "id": 148,
      "name": "Freya",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Wolf",
      "birthday": "  December 14",
      "catchphrase": "  uff da",
      "hobby": "  Fashion"
    },
    {
      "id": 149,
      "name": "Friga",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Penguin",
      "birthday": "  October 16",
      "catchphrase": "  brrmph",
      "hobby": "  Fashion"
    },
    {
      "id": 150,
      "name": "Frita",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Sheep",
      "birthday": "  July 16",
      "catchphrase": "  oh ewe",
      "hobby": "  Music"
    },
    {
      "id": 151,
      "name": "Frobert",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Frog",
      "birthday": "  February 8",
      "catchphrase": "  fribbit",
      "hobby": "  Fitness"
    },
    {
      "id": 152,
      "name": "Fuchsia",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Deer",
      "birthday": "  September 19",
      "catchphrase": "  precious",
      "hobby": "  Music"
    },
    {
      "id": 153,
      "name": "Gabi",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Rabbit",
      "birthday": "  December 16",
      "catchphrase": "  honeybun",
      "hobby": "  Fashion"
    },
    {
      "id": 154,
      "name": "Gala",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Pig",
      "birthday": "  March 5",
      "catchphrase": "  snortie",
      "hobby": "  Education"
    },
    {
      "id": 155,
      "name": "Gaston",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Rabbit",
      "birthday": "  October 28",
      "catchphrase": "  mon chou",
      "hobby": "  Education"
    },
    {
      "id": 156,
      "name": "Gayle",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Alligator",
      "birthday": "  May 17",
      "catchphrase": "  snacky",
      "hobby": "  Nature"
    },
    {
      "id": 157,
      "name": "Genji",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Rabbit",
      "birthday": "  January 21",
      "catchphrase": "  mochi",
      "hobby": "  Fitness"
    },
    {
      "id": 158,
      "name": "Gigi",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Frog",
      "birthday": "  August 11",
      "catchphrase": "  ribbette",
      "hobby": "  Fashion"
    },
    {
      "id": 159,
      "name": "Gladys",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Ostrich",
      "birthday": "  January 15",
      "catchphrase": "  stretch",
      "hobby": "  Education"
    },
    {
      "id": 160,
      "name": "Gloria",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Duck",
      "birthday": "  August 12",
      "catchphrase": "  quacker",
      "hobby": "  Fashion"
    },
    {
      "id": 161,
      "name": "Goldie",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Dog",
      "birthday": "  December 27",
      "catchphrase": "  woof",
      "hobby": "  Nature"
    },
    {
      "id": 162,
      "name": "Gonzo",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Koala",
      "birthday": "  October 13",
      "catchphrase": "  mate",
      "hobby": "  Nature"
    },
    {
      "id": 163,
      "name": "Goose",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Chicken",
      "birthday": "  October 4",
      "catchphrase": "  buh-kay",
      "hobby": "  Fitness"
    },
    {
      "id": 164,
      "name": "Graham",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Hamster",
      "birthday": "  June 20",
      "catchphrase": "  indeed",
      "hobby": "  Education"
    },
    {
      "id": 165,
      "name": "Greta",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Mouse",
      "birthday": "  September 5",
      "catchphrase": "  yelp",
      "hobby": "  Education"
    },
    {
      "id": 166,
      "name": "Grizzly",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Bear",
      "birthday": "  July 31",
      "catchphrase": "  grrr",
      "hobby": "  Education"
    },
    {
      "id": 167,
      "name": "Groucho",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Bear",
      "birthday": "  October 23r",
      "catchphrase": "  grumble",
      "hobby": "  Music"
    },
    {
      "id": 168,
      "name": "Gruff",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Goat",
      "birthday": "  August 29",
      "catchphrase": "  bleh eh eh",
      "hobby": "  Music"
    },
    {
      "id": 169,
      "name": "Gwen",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Penguin",
      "birthday": "  January 23r",
      "catchphrase": "  h-h-h-hon",
      "hobby": "  Fashion"
    },
    {
      "id": 170,
      "name": "Hamlet",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Hamster",
      "birthday": "  May 30",
      "catchphrase": "  hammie",
      "hobby": "  Play"
    },
    {
      "id": 171,
      "name": "Hamphrey",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Hamster",
      "birthday": "  February 25",
      "catchphrase": "  snort",
      "hobby": "  Nature"
    },
    {
      "id": 172,
      "name": "Hans",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Gorilla",
      "birthday": "  December 5",
      "catchphrase": "  groovy",
      "hobby": "  Fitness"
    },
    {
      "id": 173,
      "name": "Harry",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Hippo",
      "birthday": "  January 7",
      "catchphrase": "  beach bum",
      "hobby": "  Education"
    },
    {
      "id": 174,
      "name": "Hazel",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Squirrel",
      "birthday": "  August 30",
      "catchphrase": "  uni-wow",
      "hobby": "  Play"
    },
    {
      "id": 175,
      "name": "Henry",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Frog",
      "birthday": "  September 21",
      "catchphrase": "  snoozit",
      "hobby": "  Music"
    },
    {
      "id": 176,
      "name": "Hippeux",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Hippo",
      "birthday": "  October 15",
      "catchphrase": "  natch",
      "hobby": "  Education"
    },
    {
      "id": 177,
      "name": "Hopkins",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Rabbit",
      "birthday": "  March 11",
      "catchphrase": "  thumper",
      "hobby": "  Nature"
    },
    {
      "id": 178,
      "name": "Hopper",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Penguin",
      "birthday": "  April 6",
      "catchphrase": "  slushie",
      "hobby": "  Music"
    },
    {
      "id": 179,
      "name": "Hornsby",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Rhino",
      "birthday": "  March 20",
      "catchphrase": "  schnozzle",
      "hobby": "  Nature"
    },
    {
      "id": 180,
      "name": "Huck",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Frog",
      "birthday": "  July 9",
      "catchphrase": "  hopper",
      "hobby": "  Fitness"
    },
    {
      "id": 181,
      "name": "Hugh",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Pig",
      "birthday": "  December 30",
      "catchphrase": "  snortle",
      "hobby": "  Play"
    },
    {
      "id": 182,
      "name": "Iggly",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Penguin",
      "birthday": "  November 2",
      "catchphrase": "  waddler",
      "hobby": "  Fitness"
    },
    {
      "id": 183,
      "name": "Ike",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Bear",
      "birthday": "  May 16",
      "catchphrase": "  roadie",
      "hobby": "  Nature"
    },
    {
      "id": 184,
      "name": "JacobNAJakeyPAL",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Bird",
      "birthday": "  August 24",
      "catchphrase": "  ya feel",
      "hobby": "  Nature"
    },
    {
      "id": 185,
      "name": "Jacques",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Bird",
      "birthday": "  June 22",
      "catchphrase": "  zut alors",
      "hobby": "  Music"
    },
    {
      "id": 186,
      "name": "Jambette",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Frog",
      "birthday": "  October 27",
      "catchphrase": "  croak-kay",
      "hobby": "  Fashion"
    },
    {
      "id": 187,
      "name": "Jay",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Bird",
      "birthday": "  July 17",
      "catchphrase": "  heeeeeyy",
      "hobby": "  Fitness"
    },
    {
      "id": 188,
      "name": "Jeremiah",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Frog",
      "birthday": "  July 8",
      "catchphrase": "  nee-deep",
      "hobby": "  Play"
    },
    {
      "id": 189,
      "name": "Jitters",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Bird",
      "birthday": "  February 2",
      "catchphrase": "  bzzert",
      "hobby": "  Fitness"
    },
    {
      "id": 190,
      "name": "Joey",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Duck",
      "birthday": "  January 3r",
      "catchphrase": "  bleeeeeck",
      "hobby": "  Play"
    },
    {
      "id": 191,
      "name": "Judy",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Cub",
      "birthday": "  March 10",
      "catchphrase": "  myohmy",
      "hobby": "  Music"
    },
    {
      "id": 192,
      "name": "Julia",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Ostrich",
      "birthday": "  July 31",
      "catchphrase": "  dahling",
      "hobby": "  Education"
    },
    {
      "id": 193,
      "name": "Julian",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Horse",
      "birthday": "  March 15",
      "catchphrase": "  glitter",
      "hobby": "  Music"
    },
    {
      "id": 194,
      "name": "June",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Cub",
      "birthday": "  May 21",
      "catchphrase": "  rainbow",
      "hobby": "  Nature"
    },
    {
      "id": 195,
      "name": "Kabuki",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Cat",
      "birthday": "  November 29",
      "catchphrase": "  meooo-OH",
      "hobby": "  Music"
    },
    {
      "id": 196,
      "name": "Katt",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Cat",
      "birthday": "  April 27",
      "catchphrase": "  purrty",
      "hobby": "  Music"
    },
    {
      "id": 197,
      "name": "Keaton",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Eagle",
      "birthday": "  June 1",
      "catchphrase": "  wingo",
      "hobby": "  Music"
    },
    {
      "id": 198,
      "name": "Ken",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Chicken",
      "birthday": "  December 23r",
      "catchphrase": "  no doubt",
      "hobby": "  Education"
    },
    {
      "id": 199,
      "name": "Ketchup",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Duck",
      "birthday": "  July 27",
      "catchphrase": "  bitty",
      "hobby": "  Play"
    },
    {
      "id": 200,
      "name": "Kevin",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Pig",
      "birthday": "  April 26",
      "catchphrase": "  weeweewee",
      "hobby": "  Play"
    },
    {
      "id": 201,
      "name": "Kid Cat",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Cat",
      "birthday": "  August 1",
      "catchphrase": "  psst",
      "hobby": "  Fitness"
    },
    {
      "id": 202,
      "name": "Kidd",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Goat",
      "birthday": "  June 28",
      "catchphrase": "  wut",
      "hobby": "  Education"
    },
    {
      "id": 203,
      "name": "Kiki",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Cat",
      "birthday": "  October 8",
      "catchphrase": "  kitty cat",
      "hobby": "  Education"
    },
    {
      "id": 204,
      "name": "Kitt",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Kangaroo",
      "birthday": "  October 11",
      "catchphrase": "  child",
      "hobby": "  Education"
    },
    {
      "id": 205,
      "name": "Kitty",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Cat",
      "birthday": "  February 15",
      "catchphrase": "  mrowrr",
      "hobby": "  Fashion"
    },
    {
      "id": 206,
      "name": "Klaus",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Bear",
      "birthday": "  March 31",
      "catchphrase": "  strudel",
      "hobby": "  Education"
    },
    {
      "id": 207,
      "name": "Knox",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Chicken",
      "birthday": "  November 23r",
      "catchphrase": "  cluckling",
      "hobby": "  Education"
    },
    {
      "id": 208,
      "name": "Kody",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Cub",
      "birthday": "  September 28",
      "catchphrase": "  grah grah",
      "hobby": "  Fitness"
    },
    {
      "id": 209,
      "name": "Kyle",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Wolf",
      "birthday": "  December 6",
      "catchphrase": "  alpha",
      "hobby": "  Music"
    },
    {
      "id": 210,
      "name": "Leonardo",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Tiger",
      "birthday": "  May 15",
      "catchphrase": "  flexin'",
      "hobby": "  Fitness"
    },
    {
      "id": 211,
      "name": "Leopold",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Lion",
      "birthday": "  August 14",
      "catchphrase": "  lion cub",
      "hobby": "  Education"
    },
    {
      "id": 212,
      "name": "Lily",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Frog",
      "birthday": "  February 4",
      "catchphrase": "  toady",
      "hobby": "  Education"
    },
    {
      "id": 213,
      "name": "Limberg",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Mouse",
      "birthday": "  October 17",
      "catchphrase": "  squinky",
      "hobby": "  Education"
    },
    {
      "id": 214,
      "name": "Lionel",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Lion",
      "birthday": "  July 29",
      "catchphrase": "  precisely",
      "hobby": "  Music"
    },
    {
      "id": 215,
      "name": "Lobo",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Wolf",
      "birthday": "  November 5",
      "catchphrase": "  ah-rooooo",
      "hobby": "  Education"
    },
    {
      "id": 216,
      "name": "Lolly",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Cat",
      "birthday": "  March 27",
      "catchphrase": "  bonbon",
      "hobby": "  Music"
    },
    {
      "id": 217,
      "name": "Lopez",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Deer",
      "birthday": "  August 20",
      "catchphrase": "  badoom",
      "hobby": "  Education"
    },
    {
      "id": 218,
      "name": "Louie",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Gorilla",
      "birthday": "  March 26",
      "catchphrase": "  hoo hoo ha",
      "hobby": "  Fitness"
    },
    {
      "id": 219,
      "name": "Lucha",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Bird",
      "birthday": "  December 12",
      "catchphrase": "  cacaw",
      "hobby": "  Fitness"
    },
    {
      "id": 220,
      "name": "Lucky",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Dog",
      "birthday": "  November 4",
      "catchphrase": "  rrr-owch",
      "hobby": "  Play"
    },
    {
      "id": 221,
      "name": "Lucy",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Pig",
      "birthday": "  June 2",
      "catchphrase": "  snoooink",
      "hobby": "  Music"
    },
    {
      "id": 222,
      "name": "Lyman",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Koala",
      "birthday": "  October 12",
      "catchphrase": "  chips",
      "hobby": "  Play"
    },
    {
      "id": 223,
      "name": "Mac",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Dog",
      "birthday": "  November 11",
      "catchphrase": "  woo woof",
      "hobby": "  Fitness"
    },
    {
      "id": 224,
      "name": "Maddie",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Dog",
      "birthday": "  January 11",
      "catchphrase": "  yippee",
      "hobby": "  Play"
    },
    {
      "id": 225,
      "name": "Maelle",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Duck",
      "birthday": "  April 8",
      "catchphrase": "  duckling",
      "hobby": "  Fashion"
    },
    {
      "id": 226,
      "name": "Maggie",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Pig",
      "birthday": "  September 3r",
      "catchphrase": "  schep",
      "hobby": "  Nature"
    },
    {
      "id": 227,
      "name": "Mallary",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Duck",
      "birthday": "  November 17",
      "catchphrase": "  quackpth",
      "hobby": "  Fashion"
    },
    {
      "id": 228,
      "name": "Maple",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Cub",
      "birthday": "  June 15",
      "catchphrase": "  honey",
      "hobby": "  Education"
    },
    {
      "id": 229,
      "name": "Marcel",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Dog",
      "birthday": "  December 31",
      "catchphrase": "  non",
      "hobby": "  Play"
    },
    {
      "id": 230,
      "name": "Marcie",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Kangaroo",
      "birthday": "  May 31",
      "catchphrase": "  pouches",
      "hobby": "  Nature"
    },
    {
      "id": 231,
      "name": "Margie",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Elephant",
      "birthday": "  January 28",
      "catchphrase": "  tootie",
      "hobby": "  Education"
    },
    {
      "id": 232,
      "name": "Marina",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Octopus",
      "birthday": "  June 26",
      "catchphrase": "  blurp",
      "hobby": "  Music"
    },
    {
      "id": 233,
      "name": "Marshal",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Squirrel",
      "birthday": "  September 29",
      "catchphrase": "  sulky",
      "hobby": "  Music"
    },
    {
      "id": 234,
      "name": "Mathilda",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Kangaroo",
      "birthday": "  November 12",
      "catchphrase": "  wee baby",
      "hobby": "  Fitness"
    },
    {
      "id": 235,
      "name": "Megan",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Bear",
      "birthday": "  March 13",
      "catchphrase": "  sundae",
      "hobby": "  Nature"
    },
    {
      "id": 236,
      "name": "Melba",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Koala",
      "birthday": "  April 12",
      "catchphrase": "  toasty",
      "hobby": "  Education"
    },
    {
      "id": 237,
      "name": "Merengue",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Rhino",
      "birthday": "  March 19",
      "catchphrase": "  shortcake",
      "hobby": "  Nature"
    },
    {
      "id": 238,
      "name": "Merry",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Cat",
      "birthday": "  June 29",
      "catchphrase": "  mweee",
      "hobby": "  Fashion"
    },
    {
      "id": 239,
      "name": "Midge",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Bird",
      "birthday": "  March 12",
      "catchphrase": "  tweedledee",
      "hobby": "  Education"
    },
    {
      "id": 240,
      "name": "Mint",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Squirrel",
      "birthday": "  May 2",
      "catchphrase": "  ahhhhhh",
      "hobby": "  Fashion"
    },
    {
      "id": 241,
      "name": "Mira",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Rabbit",
      "birthday": "  July 6",
      "catchphrase": "  cottontail",
      "hobby": "  Fitness"
    },
    {
      "id": 242,
      "name": "Miranda",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Duck",
      "birthday": "  April 23r",
      "catchphrase": "  quackulous",
      "hobby": "  Fashion"
    },
    {
      "id": 243,
      "name": "Mitzi",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Cat",
      "birthday": "  September 25",
      "catchphrase": "  mew",
      "hobby": "  Education"
    },
    {
      "id": 244,
      "name": "Moe",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Cat",
      "birthday": "  January 12",
      "catchphrase": "  myawn",
      "hobby": "  Play"
    },
    {
      "id": 245,
      "name": "Molly",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Duck",
      "birthday": "  March 7",
      "catchphrase": "  quackidee",
      "hobby": "  Nature"
    },
    {
      "id": 246,
      "name": "Monique",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Cat",
      "birthday": "  September 30",
      "catchphrase": "  pffffft",
      "hobby": "  Fashion"
    },
    {
      "id": 247,
      "name": "Monty",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Monkey",
      "birthday": "  December 7",
      "catchphrase": "  g'tang",
      "hobby": "  Education"
    },
    {
      "id": 248,
      "name": "Moose",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Mouse",
      "birthday": "   September 13",
      "catchphrase": "  shorty",
      "hobby": "  Fitness"
    },
    {
      "id": 249,
      "name": "Mott",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Lion",
      "birthday": "   July 10",
      "catchphrase": "  cagey",
      "hobby": "  Fitness"
    },
    {
      "id": 250,
      "name": "Muffy",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Sheep",
      "birthday": "  February 14",
      "catchphrase": "  nightshade",
      "hobby": "  Music"
    },
    {
      "id": 251,
      "name": "Murphy",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Cub",
      "birthday": "  December 29",
      "catchphrase": "  malarkey",
      "hobby": "  Education"
    },
    {
      "id": 252,
      "name": "Nan",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Goat",
      "birthday": "  August 24",
      "catchphrase": "  kid",
      "hobby": "  Nature"
    },
    {
      "id": 253,
      "name": "Nana",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Monkey",
      "birthday": "  August 23r",
      "catchphrase": "  po po",
      "hobby": "  Education"
    },
    {
      "id": 254,
      "name": "Naomi",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Cow",
      "birthday": "  February 28",
      "catchphrase": "  moolah",
      "hobby": "  Fashion"
    },
    {
      "id": 255,
      "name": "Nate",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Bear",
      "birthday": "  August 16",
      "catchphrase": "  yawwwn",
      "hobby": "  Play"
    },
    {
      "id": 256,
      "name": "Nibbles",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Squirrel",
      "birthday": "  July 19",
      "catchphrase": "  niblet",
      "hobby": "  Fashion"
    },
    {
      "id": 257,
      "name": "Norma",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Cow",
      "birthday": "  September 20",
      "catchphrase": "  hoof hoo",
      "hobby": "  Nature"
    },
    {
      "id": 258,
      "name": "Octavian",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Octopus",
      "birthday": "  September 20",
      "catchphrase": "  sucker",
      "hobby": "  Play"
    },
    {
      "id": 259,
      "name": "O'Hare",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Rabbit",
      "birthday": "  July 24",
      "catchphrase": "  amigo",
      "hobby": "  Nature"
    },
    {
      "id": 260,
      "name": "Olaf",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Anteater",
      "birthday": "  May 19",
      "catchphrase": "  whiffa",
      "hobby": "  Education"
    },
    {
      "id": 261,
      "name": "Olive",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Cub",
      "birthday": "  July 12",
      "catchphrase": "  sweet pea",
      "hobby": "  Nature"
    },
    {
      "id": 262,
      "name": "Olivia",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Cat",
      "birthday": "  February 3r",
      "catchphrase": "  purrr",
      "hobby": "  Music"
    },
    {
      "id": 263,
      "name": "Opal",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Elephant",
      "birthday": "  January 20",
      "catchphrase": "  snoot",
      "hobby": "  Fashion"
    },
    {
      "id": 264,
      "name": "Ozzie",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Koala",
      "birthday": "  May 7",
      "catchphrase": "  ol' bear",
      "hobby": "  Play"
    },
    {
      "id": 265,
      "name": "Pancetti",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Pig",
      "birthday": "  November 14",
      "catchphrase": "  sooey",
      "hobby": "  Music"
    },
    {
      "id": 266,
      "name": "Pango",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Anteater",
      "birthday": "  November 9",
      "catchphrase": "  snooooof",
      "hobby": "  Fashion"
    },
    {
      "id": 267,
      "name": "Paolo",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Elephant",
      "birthday": "  May 5",
      "catchphrase": "  pal",
      "hobby": "  Nature"
    },
    {
      "id": 268,
      "name": "Papi",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Horse",
      "birthday": "  January 10",
      "catchphrase": "  haaay",
      "hobby": "  Nature"
    },
    {
      "id": 269,
      "name": "Pashmina",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Goat",
      "birthday": "  December 26",
      "catchphrase": "  kidders",
      "hobby": "  Music"
    },
    {
      "id": 270,
      "name": "Pate",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Duck",
      "birthday": "  February 23r",
      "catchphrase": "  quackle",
      "hobby": "  Fashion"
    },
    {
      "id": 271,
      "name": "Patty",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Cow",
      "birthday": "  May 10",
      "catchphrase": "  how-now",
      "hobby": "  Fashion"
    },
    {
      "id": 272,
      "name": "Paula",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Bear",
      "birthday": "  March 22",
      "catchphrase": "  yodelay",
      "hobby": "  Fitness"
    },
    {
      "id": 273,
      "name": "Peaches",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Horse",
      "birthday": "  November 28",
      "catchphrase": "  neighbor",
      "hobby": "  Education"
    },
    {
      "id": 274,
      "name": "Peanut",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Squirrel",
      "birthday": "  June 8",
      "catchphrase": "  slacker",
      "hobby": "  Fashion"
    },
    {
      "id": 275,
      "name": "Pecan",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Squirrel",
      "birthday": "  September 10",
      "catchphrase": "  chipmunk",
      "hobby": "  Fashion"
    },
    {
      "id": 276,
      "name": "Peck",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Bird",
      "birthday": "  July 25",
      "catchphrase": "  crunch",
      "hobby": "  Play"
    },
    {
      "id": 277,
      "name": "Peewee",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Gorilla",
      "birthday": "  September 11",
      "catchphrase": "  li'l bitty baby",
      "hobby": "  Fitness"
    },
    {
      "id": 278,
      "name": "Peggy",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Pig",
      "birthday": "  May 23r",
      "catchphrase": "  shweetie",
      "hobby": "  Fashion"
    },
    {
      "id": 279,
      "name": "Pekoe",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Cub",
      "birthday": "  May 18",
      "catchphrase": "  bud",
      "hobby": "  Nature"
    },
    {
      "id": 280,
      "name": "Penelope",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Mouse",
      "birthday": "  February 5",
      "catchphrase": "  oh bow",
      "hobby": "  Fashion"
    },
    {
      "id": 281,
      "name": "Phil",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Ostrich",
      "birthday": "  November 27",
      "catchphrase": "  hurk",
      "hobby": "  Music"
    },
    {
      "id": 282,
      "name": "Phoebe",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Ostrich",
      "birthday": "  April 22",
      "catchphrase": "  sparky",
      "hobby": "  Fitness"
    },
    {
      "id": 283,
      "name": "Pierce",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Eagle",
      "birthday": "  January 8",
      "catchphrase": "  hawkeye",
      "hobby": "  Fitness"
    },
    {
      "id": 284,
      "name": "Pietro",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Sheep",
      "birthday": "  April 19",
      "catchphrase": "  honk honk",
      "hobby": "  Music"
    },
    {
      "id": 285,
      "name": "Pinky",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Bear",
      "birthday": "  September 9",
      "catchphrase": "  wah",
      "hobby": "  Fashion"
    },
    {
      "id": 286,
      "name": "Piper",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Bird",
      "birthday": "  April 18",
      "catchphrase": "  chickadee",
      "hobby": "  Play"
    },
    {
      "id": 287,
      "name": "Pippy",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Rabbit",
      "birthday": "  June 14",
      "catchphrase": "  li'l hare",
      "hobby": "  Fashion"
    },
    {
      "id": 288,
      "name": "Plucky",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Chicken",
      "birthday": "  October 12",
      "catchphrase": "  chicky-poo",
      "hobby": "  Play"
    },
    {
      "id": 289,
      "name": "Pompom",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Duck",
      "birthday": "  February 11",
      "catchphrase": "  rah rah",
      "hobby": "  Music"
    },
    {
      "id": 290,
      "name": "Poncho",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Cub",
      "birthday": "  January 2",
      "catchphrase": "  li'l bear",
      "hobby": "  Fitness"
    },
    {
      "id": 291,
      "name": "Poppy",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Squirrel",
      "birthday": "  August 5",
      "catchphrase": "  nutty",
      "hobby": "  Education"
    },
    {
      "id": 292,
      "name": "Portia",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Dog",
      "birthday": "  October 25",
      "catchphrase": "  ruffian",
      "hobby": "  Fashion"
    },
    {
      "id": 293,
      "name": "Prince",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Frog",
      "birthday": "  July 21",
      "catchphrase": "  burrup",
      "hobby": "  Play"
    },
    {
      "id": 294,
      "name": "Puck",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Penguin",
      "birthday": "  February 21",
      "catchphrase": "  brrrrrrrrr",
      "hobby": "  Fitness"
    },
    {
      "id": 295,
      "name": "Puddles",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Frog",
      "birthday": "  January 13",
      "catchphrase": "  splish",
      "hobby": "  Fashion"
    },
    {
      "id": 296,
      "name": "Pudge",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Cub",
      "birthday": "  June 11",
      "catchphrase": "  golly",
      "hobby": "  Play"
    },
    {
      "id": 297,
      "name": "Punchy",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Cat",
      "birthday": "  April 11",
      "catchphrase": "  mrmpht",
      "hobby": "  Play"
    },
    {
      "id": 298,
      "name": "Purrl",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Cat",
      "birthday": "  May 29",
      "catchphrase": "  kitten",
      "hobby": "  Fashion"
    },
    {
      "id": 299,
      "name": "Queenie",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Ostrich",
      "birthday": "  November 13",
      "catchphrase": "  chicken",
      "hobby": "  Fashion"
    },
    {
      "id": 300,
      "name": "Quillson",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Duck",
      "birthday": "  December 22",
      "catchphrase": "  ridukulous",
      "hobby": "  Music"
    },
    {
      "id": 301,
      "name": "Raddle",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Frog",
      "birthday": "  June 6",
      "catchphrase": "  aaach—",
      "hobby": "  Nature"
    },
    {
      "id": 302,
      "name": "Rasher",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Pig",
      "birthday": "  April 7",
      "catchphrase": "  swine",
      "hobby": "  Music"
    },
    {
      "id": 303,
      "name": "Raymond",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Cat",
      "birthday": "  October 1",
      "catchphrase": "  crisp",
      "hobby": "  Nature"
    },
    {
      "id": 304,
      "name": "Renée",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Rhino",
      "birthday": "  May 28",
      "catchphrase": "  yo yo yo",
      "hobby": "  Music"
    },
    {
      "id": 305,
      "name": "Reneigh",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Horse",
      "birthday": "  June 4",
      "catchphrase": "  ayup yup",
      "hobby": "  Play"
    },
    {
      "id": 306,
      "name": "Rex",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Lion",
      "birthday": "  July 24",
      "catchphrase": "  cool cat",
      "hobby": "  Nature"
    },
    {
      "id": 307,
      "name": "Rhonda",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Rhino",
      "birthday": "  January 24",
      "catchphrase": "  bigfoot",
      "hobby": "  Music"
    },
    {
      "id": 308,
      "name": "Ribbot",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Frog",
      "birthday": "  February 13",
      "catchphrase": "  zzrrbbitt",
      "hobby": "  Fitness"
    },
    {
      "id": 309,
      "name": "Ricky",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Squirrel",
      "birthday": "  September 14",
      "catchphrase": "  nutcase",
      "hobby": "  Education"
    },
    {
      "id": 310,
      "name": "Rizzo",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Mouse",
      "birthday": "  January 17",
      "catchphrase": "  squee",
      "hobby": "  Education"
    },
    {
      "id": 311,
      "name": "Roald",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Penguin",
      "birthday": "  January 5",
      "catchphrase": "  b-b-buddy",
      "hobby": "  Fitness"
    },
    {
      "id": 312,
      "name": "Robin",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Bird",
      "birthday": "  December 4",
      "catchphrase": "  la-di-da",
      "hobby": "  Fashion"
    },
    {
      "id": 313,
      "name": "Rocco",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Hippo",
      "birthday": "  August 18",
      "catchphrase": "  hippie",
      "hobby": "  Education"
    },
    {
      "id": 314,
      "name": "Rocket",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Gorilla",
      "birthday": "  April 14",
      "catchphrase": "  vroom",
      "hobby": "  Fitness"
    },
    {
      "id": 315,
      "name": "Rod",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Mouse",
      "birthday": "  August 14",
      "catchphrase": "  ace",
      "hobby": "  Fitness"
    },
    {
      "id": 316,
      "name": "Rodeo",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Bull",
      "birthday": "  October 29",
      "catchphrase": "  chaps",
      "hobby": "  Fitness"
    },
    {
      "id": 317,
      "name": "Rodney",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Hamster",
      "birthday": "  November 10",
      "catchphrase": "  le ham",
      "hobby": "  Music"
    },
    {
      "id": 318,
      "name": "Rolf",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Tiger",
      "birthday": "  August 22",
      "catchphrase": "  grrrolf",
      "hobby": "  Fitness"
    },
    {
      "id": 319,
      "name": "Rooney",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Kangaroo",
      "birthday": "  December 1",
      "catchphrase": "  punches",
      "hobby": "  Fitness"
    },
    {
      "id": 320,
      "name": "Rory",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Lion",
      "birthday": "  August 7",
      "catchphrase": "  capital",
      "hobby": "  Music"
    },
    {
      "id": 321,
      "name": "Roscoe",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Horse",
      "birthday": "  June 16",
      "catchphrase": "  nay",
      "hobby": "  Music"
    },
    {
      "id": 322,
      "name": "Rosie",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Cat",
      "birthday": "  February 27",
      "catchphrase": "  silly",
      "hobby": "  Music"
    },
    {
      "id": 323,
      "name": "Rowan",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Tiger",
      "birthday": "  August 26",
      "catchphrase": "  mango",
      "hobby": "  Fitness"
    },
    {
      "id": 324,
      "name": "Ruby",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Rabbit",
      "birthday": "  December 25",
      "catchphrase": "  li'l ears",
      "hobby": "  Nature"
    },
    {
      "id": 325,
      "name": "Rudy",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Cat",
      "birthday": "  December 20",
      "catchphrase": "  mush",
      "hobby": "  Play"
    },
    {
      "id": 326,
      "name": "Sally",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Squirrel",
      "birthday": "  June 19",
      "catchphrase": "  nutmeg",
      "hobby": "  Music"
    },
    {
      "id": 327,
      "name": "Samson",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Mouse",
      "birthday": "  July 5",
      "catchphrase": "  pipsqueak",
      "hobby": "  Fitness"
    },
    {
      "id": 328,
      "name": "Sandy",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Ostrich",
      "birthday": "  October 21",
      "catchphrase": "  speedy",
      "hobby": "  Nature"
    },
    {
      "id": 329,
      "name": "Savannah",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Horse",
      "birthday": "  January 25",
      "catchphrase": "  y'all",
      "hobby": "  Music"
    },
    {
      "id": 330,
      "name": "Scoot",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Duck",
      "birthday": "  June 13",
      "catchphrase": "  zip zoom",
      "hobby": "  Fitness"
    },
    {
      "id": 331,
      "name": "Shari",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Monkey",
      "birthday": "  April 10",
      "catchphrase": "  cheeky",
      "hobby": "  Music"
    },
    {
      "id": 332,
      "name": "Sheldon",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Squirrel",
      "birthday": "  February 26",
      "catchphrase": "  cardio",
      "hobby": "  Play"
    },
    {
      "id": 333,
      "name": "Shep",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Dog",
      "birthday": "  November 24",
      "catchphrase": "  baa baa baa",
      "hobby": "  Education"
    },
    {
      "id": 334,
      "name": "Sherb",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Goat",
      "birthday": "  January 18",
      "catchphrase": "  bawwww",
      "hobby": "  Nature"
    },
    {
      "id": 335,
      "name": "Simon",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Monkey",
      "birthday": "  January 19",
      "catchphrase": "  zzzook",
      "hobby": "  Play"
    },
    {
      "id": 336,
      "name": "Skye",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Wolf",
      "birthday": "  March 24",
      "catchphrase": "  airmail",
      "hobby": "  Music"
    },
    {
      "id": 337,
      "name": "Sly",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Alligator",
      "birthday": "  November 15",
      "catchphrase": "  hoo-rah",
      "hobby": "  Play"
    },
    {
      "id": 338,
      "name": "Snake",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Rabbit",
      "birthday": "  November 3r",
      "catchphrase": "  bunyip",
      "hobby": "  Fitness"
    },
    {
      "id": 339,
      "name": "Snooty",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Anteater",
      "birthday": "  October 24",
      "catchphrase": "  sniffff",
      "hobby": "  Education"
    },
    {
      "id": 340,
      "name": "Soleil",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Hamster",
      "birthday": "  August 9",
      "catchphrase": "  tarnation",
      "hobby": "  Education"
    },
    {
      "id": 341,
      "name": "Sparro",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Bird",
      "birthday": "  November 20",
      "catchphrase": "  like whoa",
      "hobby": "  Play"
    },
    {
      "id": 342,
      "name": "Spike",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Rhino",
      "birthday": "  June 17",
      "catchphrase": "  punk",
      "hobby": "  Nature"
    },
    {
      "id": 343,
      "name": "SporkNACracklePAL",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Pig",
      "birthday": "  September 3r",
      "catchphrase": "  snork",
      "hobby": "  Play"
    },
    {
      "id": 344,
      "name": "Sprinkle",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Penguin",
      "birthday": "  February 20",
      "catchphrase": "  frappe",
      "hobby": "  Play"
    },
    {
      "id": 345,
      "name": "Sprocket",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Ostrich",
      "birthday": "  December 1",
      "catchphrase": "  zort",
      "hobby": "  Music"
    },
    {
      "id": 346,
      "name": "Static",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Squirrel",
      "birthday": "  July 9",
      "catchphrase": "  krzzt",
      "hobby": "  Music"
    },
    {
      "id": 347,
      "name": "Stella",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Sheep",
      "birthday": "  April 9",
      "catchphrase": "  baa-dabing",
      "hobby": "  Nature"
    },
    {
      "id": 348,
      "name": "Sterling",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Eagle",
      "birthday": "  December 11",
      "catchphrase": "  skraaaaw",
      "hobby": "  Fitness"
    },
    {
      "id": 349,
      "name": "Stinky",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Cat",
      "birthday": "  August 17",
      "catchphrase": "  GAAHHH",
      "hobby": "  Fitness"
    },
    {
      "id": 350,
      "name": "Stitches",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Cub",
      "birthday": "  February 10",
      "catchphrase": "  stuffin'",
      "hobby": "  Play"
    },
    {
      "id": 351,
      "name": "Stu",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Bull",
      "birthday": "  April 20",
      "catchphrase": "  mrooooo",
      "hobby": "  Nature"
    },
    {
      "id": 352,
      "name": "Sydney",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Koala",
      "birthday": "  June 21",
      "catchphrase": "  sunshine",
      "hobby": "  Music"
    },
    {
      "id": 353,
      "name": "Sylvana",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Squirrel",
      "birthday": "  October 22",
      "catchphrase": "  hubbub",
      "hobby": "  Nature"
    },
    {
      "id": 354,
      "name": "Sylvia",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Kangaroo",
      "birthday": "  May 3r",
      "catchphrase": "  boing",
      "hobby": "  Music"
    },
    {
      "id": 355,
      "name": "Tabby",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Cat",
      "birthday": "  August 13",
      "catchphrase": "  me-WOW",
      "hobby": "  Music"
    },
    {
      "id": 356,
      "name": "Tad",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Frog",
      "birthday": "  August 3r",
      "catchphrase": "  sluuuurp",
      "hobby": "  Play"
    },
    {
      "id": 357,
      "name": "Tammi",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Monkey",
      "birthday": "  April 2",
      "catchphrase": "  chimpy",
      "hobby": "  Fashion"
    },
    {
      "id": 358,
      "name": "Tammy",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Cub",
      "birthday": "  June 23r",
      "catchphrase": "  ya heard",
      "hobby": "  Play"
    },
    {
      "id": 359,
      "name": "Tangy",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Cat",
      "birthday": "  June 17",
      "catchphrase": "  reeeeOWR",
      "hobby": "  Music"
    },
    {
      "id": 360,
      "name": "Tank",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Rhino",
      "birthday": "  May 6",
      "catchphrase": "  kerPOW",
      "hobby": "  Fitness"
    },
    {
      "id": 361,
      "name": "Tasha",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Squirrel",
      "birthday": "  November 30",
      "catchphrase": "  nice nice",
      "hobby": "  Fitness"
    },
    {
      "id": 362,
      "name": "T-Bone",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Bull",
      "birthday": "  May 20",
      "catchphrase": "  moocher",
      "hobby": "  Education"
    },
    {
      "id": 363,
      "name": "Teddy",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Bear",
      "birthday": "  September 26",
      "catchphrase": "  grooof",
      "hobby": "  Fitness"
    },
    {
      "id": 364,
      "name": "Tex",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Penguin",
      "birthday": "  October 6",
      "catchphrase": "  picante",
      "hobby": "  Music"
    },
    {
      "id": 365,
      "name": "Tia",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Elephant",
      "birthday": "  November 18",
      "catchphrase": "  teacup",
      "hobby": "  Nature"
    },
    {
      "id": 366,
      "name": "Tiffany",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Rabbit",
      "birthday": "  January 9",
      "catchphrase": "  bun bun",
      "hobby": "  Fashion"
    },
    {
      "id": 367,
      "name": "Timbra",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Sheep",
      "birthday": "  October 21",
      "catchphrase": "  pine nut",
      "hobby": "  Education"
    },
    {
      "id": 368,
      "name": "Tipper",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Cow",
      "birthday": "  August 25",
      "catchphrase": "  pushy",
      "hobby": "  Fashion"
    },
    {
      "id": 369,
      "name": "Tom",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Cat",
      "birthday": "  December 10",
      "catchphrase": "  me-YOWZA",
      "hobby": "  Education"
    },
    {
      "id": 370,
      "name": "Truffles",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Pig",
      "birthday": "  July 28",
      "catchphrase": "  snoutie",
      "hobby": "  Fashion"
    },
    {
      "id": 371,
      "name": "Tucker",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Elephant",
      "birthday": "  September 7",
      "catchphrase": "  fuzzers",
      "hobby": "  Nature"
    },
    {
      "id": 372,
      "name": "Tutu",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Bear",
      "birthday": "  September 15",
      "catchphrase": "  twinkles",
      "hobby": "  Fashion"
    },
    {
      "id": 373,
      "name": "Twiggy",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Bird",
      "birthday": "  July 13",
      "catchphrase": "  cheepers",
      "hobby": "  Fashion"
    },
    {
      "id": 374,
      "name": "Tybalt",
      "gender": "Male",
      "personality": "Jock",
      "species": "  Tiger",
      "birthday": "  August 19",
      "catchphrase": "  grrrRAH",
      "hobby": "  Play"
    },
    {
      "id": 375,
      "name": "Ursala",
      "gender": "Female",
      "personality": "Sisterly",
      "species": "  Bear",
      "birthday": "  January 16",
      "catchphrase": "  grooomph",
      "hobby": "  Music"
    },
    {
      "id": 376,
      "name": "Velma",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Goat",
      "birthday": "  January 14",
      "catchphrase": "  blih",
      "hobby": "  Education"
    },
    {
      "id": 377,
      "name": "Vesta",
      "gender": "Female",
      "personality": "Normal",
      "species": "  Sheep",
      "birthday": "  April 16",
      "catchphrase": "  baaaffo",
      "hobby": "  Fashion"
    },
    {
      "id": 378,
      "name": "Vic",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Bull",
      "birthday": "  December 29",
      "catchphrase": "  cud",
      "hobby": "  Fitness"
    },
    {
      "id": 379,
      "name": "Victoria",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Horse",
      "birthday": "  July 11",
      "catchphrase": "  sugar cube",
      "hobby": "  Fitness"
    },
    {
      "id": 380,
      "name": "Violet",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Gorilla",
      "birthday": "  September 1",
      "catchphrase": "  sweetie",
      "hobby": "  Fitness"
    },
    {
      "id": 381,
      "name": "Vivian",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Wolf",
      "birthday": "  January 26",
      "catchphrase": "  piffle",
      "hobby": "  Education"
    },
    {
      "id": 382,
      "name": "Vladimir",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Cub",
      "birthday": "  August 2",
      "catchphrase": "  nyet",
      "hobby": "  Play"
    },
    {
      "id": 383,
      "name": "Wade",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Penguin",
      "birthday": "  October 30",
      "catchphrase": "  so it goes",
      "hobby": "  Nature"
    },
    {
      "id": 384,
      "name": "Walker",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Dog",
      "birthday": "  June 10",
      "catchphrase": "  wuh",
      "hobby": "  Play"
    },
    {
      "id": 385,
      "name": "Walt",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Kangaroo",
      "birthday": "  April 24",
      "catchphrase": "  pockets",
      "hobby": "  Fitness"
    },
    {
      "id": 386,
      "name": "Wart Jr.",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Frog",
      "birthday": "  August 21",
      "catchphrase": "  grr-ribbit",
      "hobby": "  Education"
    },
    {
      "id": 387,
      "name": "Weber",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Duck",
      "birthday": "  June 30",
      "catchphrase": "  quaa",
      "hobby": "  Nature"
    },
    {
      "id": 388,
      "name": "Wendy",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Sheep",
      "birthday": "  August 15",
      "catchphrase": "  lambkins",
      "hobby": "  Fashion"
    },
    {
      "id": 389,
      "name": "Whitney",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Wolf",
      "birthday": "  September 17",
      "catchphrase": "  snappy",
      "hobby": "  Fashion"
    },
    {
      "id": 390,
      "name": "Willow",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Sheep",
      "birthday": "  November 26",
      "catchphrase": "  bo peep",
      "hobby": "  Fashion"
    },
    {
      "id": 391,
      "name": "Winnie",
      "gender": "Female",
      "personality": "Peppy",
      "species": "  Horse",
      "birthday": "  January 31",
      "catchphrase": "  hay-OK",
      "hobby": "  Fashion"
    },
    {
      "id": 392,
      "name": "Wolfgang",
      "gender": "Male",
      "personality": "Cranky",
      "species": "  Wolf",
      "birthday": "  November 25",
      "catchphrase": "  snarrrl",
      "hobby": "  Education"
    },
    {
      "id": 393,
      "name": "Yuka",
      "gender": "Female",
      "personality": "Snooty",
      "species": "  Koala",
      "birthday": "  July 20",
      "catchphrase": "  tsk tsk",
      "hobby": "  Fashion"
    },
    {
      "id": 394,
      "name": "Zell",
      "gender": "Male",
      "personality": "Smug",
      "species": "  Deer",
      "birthday": "  June 7",
      "catchphrase": "  pronk",
      "hobby": "  Music"
    },
    {
      "id": 395,
      "name": "Zucker",
      "gender": "Male",
      "personality": "Lazy",
      "species": "  Octopus",
      "birthday": "  March 8",
      "catchphrase": "  bloop",
      "hobby": "  Nature"
    }
   ];